module.exports = __webpack_public_path__ + "images/8628a97.jpg";